import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postData, postDataWithParams } from "../../../service/Service";

const initialState = {
  data: {
    dashboard: [],
    dashboardNo: [],
    reportAll: [],
    detail: []
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getReportActivity = createAsyncThunk(
  "farmer/report/daily-activity",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/daily-activity/report/activity",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getReportNoActivity = createAsyncThunk(
  "farmer/report/no-daily-activity",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/daily-activity/report/no-activity",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getReportActivityAll = createAsyncThunk(
  "/farmer/daily-activity/report",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/daily-activity/report",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getReportActivityDetail = createAsyncThunk(
  "petani/report/daily-activity/detail",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/daily-activity/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const reportDailyActivity = createSlice({
  name: "Report Daily Activity",
  initialState: initialState,
  extraReducers: {
    [getReportActivity.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportActivity.fulfilled]: (state, action) => {
      state.data.dashboard = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getReportNoActivity.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportNoActivity.fulfilled]: (state, action) => {
      state.data.dashboardNo = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportNoActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getReportActivityAll.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportActivityAll.fulfilled]: (state, action) => {
      state.data.reportAll = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportActivityAll.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getReportActivityDetail.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportActivityDetail.fulfilled]: (state, action) => {
      state.data.detail = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportActivityDetail.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
  },
});

export const reportDailyActivityActions = reportDailyActivity.actions;

export default reportDailyActivity.reducer;
